import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  header: 'Keskeytä uudet tilaukset',
  sections: {
    pause_orders: {
      title: 'Kuinka kauan olet poissa käytöstä?',
      description: 'Ilmoitamme asiakkaille, ettet tällä hetkellä ota vastaan uusia tilauksia',
    },
    order_methods: {
      title: 'Omat tilaustavat',
      description: 'Ota käyttöön tai poista käytöstä tilaustavat, joilla asiakkaat voivat tilata sinulta',
    },
    delivery_mode: {
      title: 'Toimitustavat',
      description: 'Vaihda oman ja meidän kuljettajaverkostomme välillä',
    },
  },
  form: {
    orders_paused_until: {
      options: {
        '10_min': '10 min',
        '15_min': '15 min',
        '20_min': '20 min',
        '25_min': '25 min',
        '1_hour': '1 tunti',
        '2_hours': '2 tuntia',
        rest_of_day: 'Loppupäivä',
      },
    },
    has_standalone_delivery: {
      label: 'Omat kuljettajat',
    },
    has_external_delivery: {
      label: '{{provider}}-kuljettajaverkosto',
    },
  },
  labels: {
    delivery_orders_off: 'Toimitustilaukset pois päältä',
    delivery_orders_on: 'Toimitustilaukset päällä',
  },
  modals: {
    toggle_delivery: {
      [true]: {
        title: 'Haluatko varmasti ottaa toimitustilaukset käyttöön?',
        description: '',
      },
      [false]: {
        title: 'Haluatko varmasti poistaa toimitustilaukset käytöstä?',
        description: '',
      },
    },
    switch_delivery_mode: {
      [DeliveryMode.Internal]: {
        title: 'Haluatko varmasti vaihtaa omiin kuljettajiin?',
        description: '',
      },
      [DeliveryMode.External]: {
        title: 'Haluatko varmasti vaihtaa {{provider}}-kuljettajiin?',
        description: '',
      },
    },
  },
  buttons: {
    confirm: 'Vahvista',
    cancel: 'Peruuta',
  },
  toasts: {
    failed_to_save_changes: 'Muutosten tallennus epäonnistui',
    changes_got_saved: 'Muutokset tallennettu onnistuneesti',
  },
};
